module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/NoResults/jobbers-6a78787b267f0444428c784d9cbcd777.svg";